import React, { useEffect, useState } from "react";
import "./AttendanceNew.css";
import ATick from "../images/ATick.png";
import AClose from "../images/AClose.png";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import icPresent from "../images/ic_present.svg";
import icAbsent from "../images/ic_absent.svg";
import DatePicker from "react-datepicker"; // Import a date picker library
import "react-datepicker/dist/react-datepicker.css"; // Include CSS for the date picker
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { format } from "date-fns";
import { Oval } from "react-loader-spinner";
import BadgeIcon from "@mui/icons-material/Badge";
// import { TextField } from "@mui/material";
import Chip from "@mui/material/Chip";
import user1 from "../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";

// import absent from "../../images/absent.svg";
import absent from "../../images/absent.svg";



const OnLeave = ({ onAbsenteesCountChange , onLeaveCountChange }) => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [selectedTab, setSelectedTab] = useState("Present");

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [attendanceApiData, setAttendanceApiData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);

  const [showLoader, setShowLoader] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [base_url, setBaseUrl] = useState(`${base_url_from_axios_config}/`);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false); // Hide the date picker after selecting a date
  };

  const fetchAttendanceData = async (date) => {
    setShowLoader(true);
    const formattedDate = format(date, "YYYY-MMM-DD");
    try {
      const response = await axios.get(
        `${base_url}api/CpaysCount/${companyCode}/ATTENDANCEDAILY_LEAVE/-/-`
      );

      if (response.status === 200) {

        console.log("attendance api data", response.data);
        console.log("attendance api data22", response?.data[0].Cnt);
        setAttendanceApiData(response.data);
        // setOnLeaveCount(response?.data?.entry.Cnt)
        onLeaveCountChange(response?.data[0].Cnt)
        setShowLoader(false);
      }
    } catch (error) {
      console.log("fetchAttendanceDataErr", error);
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (selectedDate && base_url) {
      fetchAttendanceData(selectedDate);
    }
  }, [selectedDate, base_url]);

  // useEffect(() => {
  //   // Filter data based on the selected tab
  //   const filtered = attendanceApiData.filter((item) =>
  //     selectedTab === "Absent"
  //       ? item.STAT === "PRESENT"
  //       : item.STAT === "ABSENT"
  //   );
  //   // console.log('absentees count',filtered.length)
  //   setFilteredData(filtered);
  // }, [selectedTab, attendanceApiData]);

  useEffect(() => {
    // Filter data based on the selected tab
    // const filtered = attendanceApiData.filter((item) =>
    //   selectedTab === "Absent"
    //     ? item.STAT === "PRESENT"
    //     : item.STAT === "ABSENT"
    // );
    // console.log("absentees count", filtered.length);
    // onAbsenteesCountChange(filtered.length);
    // setFilteredData(filtered);
    setFilteredData(attendanceApiData);

    
  }, [selectedTab, attendanceApiData, onAbsenteesCountChange]);

  const filteredRecords = () => {
    return filteredData?.filter((d) =>
      d.Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };


    const fetchProfilePic = (ImagePath) => {
      console.log('ImagePath:',ImagePath)
      const filePath = ImagePath.replace(/\\/g, "/");
      const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)
      
      // Construct the full URL for the image
      console.log(`final url:,${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`)
      return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
    };

  return (
    // <div className="AnewWrap">
    //   <div className="AnewHead">
    //     <div className="ATopCont" style={{ position: "relative" }}>
    //       <div className="w-100 d-flex">
    //         <div
    //           style={{ fontSize: "14px", color: "#000000", fontWeight: "bold" }}
    //         >
    //           Absentees
    //         </div>
    //       </div>
    //       <div
    //         onClick={() => setShowDatePicker(!showDatePicker)}
    //         style={{
    //           cursor: "pointer",
    //           display: "inline-flex",
    //           alignItems: "center",
    //           justifyContent: "end",
    //           minWidth: "150px",
    //           fontSize: "14px",
    //         }}
    //       >
    //         <MdOutlineKeyboardArrowLeft />
    //         {selectedDate.toDateString() === new Date().toDateString()
    //           ? "today"
    //           : selectedDate.toDateString()}
    //       </div>

    //       {showDatePicker && (
    //         <div
    //           style={{
    //             position: "absolute",
    //             right: 0,
    //             top: "100%",
    //             zIndex: 10,
    //           }}
    //         >
    //           <DatePicker
    //             selected={selectedDate}
    //             onChange={handleDateChange}
    //             inline
    //           />
    //         </div>
    //       )}
    //     </div>
    //   </div>

    //   <div className="AnewLoopWrap">
    //     {showLoader && (
    //       <Oval
    //         visible={true}
    //         height="50"
    //         width="50"
    //         color="#4fa94d"
    //         ariaLabel="oval-loading"
    //         wrapperStyle={{}}
    //         wrapperClass=""
    //       />
    //     )}

    //     {!showLoader &&
    //       filteredData &&
    //       filteredData.map((entry, index) => (
    //         <div className="AnewLoopItem" key={index}>
    //           {/* <div className='AAStatusImg'>
    //                         <img
    //                             src={entry.STAT === 'PRESENT' ? icPresent : icAbsent}
    //                             alt={entry.STAT}
    //                         />
    //                     </div> */}

    //           <div className="AAUserName ms-2">{entry.EmpId}</div>

    //           <div className="ms-4">
    //             <div className="AAStatus">{entry.Name}</div>
    //           </div>

    //           <div className="ms-4">
    //             <span>{"("}</span>
    //             {entry.JobTitle}
    //             <span>{")"}</span>
    //           </div>
    //         </div>
    //       ))}

    //     {!showLoader && filteredData.length === 0 && (
    //       <div
    //         style={{
    //           textAlign: "center",
    //           color: "#d5c9c9",
    //         }}
    //       >
    //         No Data Available
    //       </div>
    //     )}
    //   </div>
    // </div>

    <div className="p-2 rounded-xl bg-white ">
      {/* Header */}
      <div className="flex justify-center items-center mb-2 w-full relative">
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full px-4 py-2 ml-2 mr-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
        />
        {/* <div
          className="text-sm text-gray-600 hover:text-black cursor-pointer flex items-center gap-1"
          onClick={() => setShowDatePicker(!showDatePicker)}
        >
          <MdOutlineKeyboardArrowLeft className="text-lg" />
          {selectedDate.toDateString() === new Date().toDateString()
            ? "Today"
            : selectedDate.toDateString()}
        </div> */}

        {/* {showDatePicker && (
          <div className="absolute top-full right-0 z-20">
            <DatePicker
              selected={selectedDate}
              onChange={handleDateChange}
              inline
            />
          </div>
        )} */}
      </div>

      {/* Loader */}
      {showLoader && (
        <div className="flex justify-center py-6">
          <Oval
            visible={true}
            height={50}
            width={50}
            color="#4fa94d"
            ariaLabel="oval-loading"
          />
        </div>
      )}

      {/* List */}
      {!showLoader && filteredData && filteredData.length > 0 && (
        <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
          {filteredRecords().map((entry, index) => (
            <div
              key={index}
              className="mx-2 flex justify-between items-center gap-4 border p-3 rounded-lg hover:bg-gray-50"
            >
              <div className="flex justify-left items-center gap-4">
            <div className="relative">
                <div className="group-hover:animate-bounce absolute z-30 -top-3 -left-1 flex justify-center items-center rounded-full p-[2px] bg-transparent ">
                  <img className="w-[14px]" src={absent} alt="Absent" />
                </div>
              <div className="w-[40px] h-[40px] rounded-full overflow-hidden flex items-center justify-center bg-gray-100">

             
              {entry.imagepath ? (
                <img
                  className="w-[80px] h-[65px] object-cover rounded-full shadow-md"
                  src={fetchProfilePic(entry.imagepath)}
                  alt="Profile"
                />
              ) : (
                <img
                  className="w-[50px] h-[50px] object-cover"
                  src={user1}
                  alt="Default Profile"
                />
              )}
              </div>
              </div>
              <div>
                {/* <div className="flex justify-between items-center w-full bg-red-100"> */}
                <span className="font-medium text-gray-800">{entry.Name}</span>

                {/* </div> */}
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500">{entry.EmpId}</span>
                  <span className="text-sm text-gray-400">
                    {entry.JobTitle}
                  </span>
                </div>

{entry?.Notes && 
                <div className="flex flex-col">
                  <span className="text-sm text-gray-500 mt-2">Notes:  {entry?.Notes}</span>
              </div>
}
              </div>
              </div>
              <div className="flex justify-right">
                                <div className="ml-2">
                  {/* <span className="text-xs px-2 py-1 bg-[#edf7f6] text-[#4db6ac] border border-[#aadfda] rounded-full">
                    {item.EmpId}
                  </span> */}

                  <Chip
                    size="small"
                    icon={
                      <BadgeIcon
                        style={{ color: "white" }}
                        className="w-3 h-3"
                      />
                    }
                    label={entry.EmpId}
                    sx={{
                      backgroundColor: "#03a1fc", // bg-red-100 equivalent
                      color: "white", // White text
                      "& .MuiChip-icon": {
                        color: "white",
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {!showLoader && filteredData.length === 0 && (
        <div className="text-center text-gray-400 py-6">No Data Available</div>
      )}
    </div>
  );
};

export default OnLeave;
